import { useTranslation } from 'react-i18next';

interface Props {
  statusKey: string;
}

const StateText = ({ statusKey }: Props) => {
  const { t } = useTranslation();

  return <span>{t(`common.state.${statusKey}`)}</span>;
};

export default StateText;
